import { createSelector } from 'reselect';

const getIsFetching = state => state.groups.isFetching;
const getTotalGroups = state => state.groups.totalGroups;
const getError = state => state.groups.error;
const getIsCreating = state => state.groups.isCreating;
const getCreationError = state => state.groups.creationError;
const getEdition = state => state.groups.edition;
const getMembersSuggestion = state => state.groups.memberSuggestions;
const getSuggestionsError = state => state.groups.suggestionsError;
const getTotalMemberSuggestions = state => state.groups.totalMemberSuggestions;
const getIsFetchingMemberSuggestions = state => state.groups.isFetchingMemberSuggestions;
const getMembers = state => state.groups.members;
const getGroupGeneralInformationReady = state => state.groups.groupGeneralInformationReady;
const getGroupExpressConfigurationReady = state => state.groups.groupExpressConfigurationReady;
const getGroupUsersConfigurationReady = state => state.groups.groupUsersConfigurationReady;
const getMusicOnHold = state => state.groups.musicOnHold;
const getDefaultExtensionSuggestions = state => state.groups.defaultExtensionSuggestions;
const getDefaultExtensionSearchText = state => state.groups.defaultExtensionSearchText;
const getIsFetchingDefaultExtensionSuggestions = state => state.groups.isFetchingDefaultExtensionSuggestions;
const getTotalDefaultExtensionSuggestions = state => state.groups.totalDefaultExtensionSuggestions;

export const getSearchText = state => state.groups.searchText;

export const getGroups = state => state.groups.groups;

export const getGroupGeneralInformation = state => state.groups.groupGeneralInformation;

export const getGroupExpressConfiguration = state => state.groups.groupExpressConfiguration;

export const getGroupUsersConfiguration = state => state.groups.groupUsersConfiguration;

export const groupExpressConfigurationSelector = createSelector(
    getGroupExpressConfiguration,
    groupExpressConfiguration => groupExpressConfiguration
);

export const groupGeneralInformationReadySelector = createSelector(
    getGroupGeneralInformationReady,
    groupGeneralInformationReady => groupGeneralInformationReady
);

export const groupExpressConfigurationReadySelector = createSelector(
    getGroupExpressConfigurationReady,
    groupExpressConfigurationReady => groupExpressConfigurationReady
);

export const groupUsersConfigurationReadySelector = createSelector(
    getGroupUsersConfigurationReady,
    groupUsersConfigurationReady => groupUsersConfigurationReady
);

export const canCreateSelector = createSelector(
    getGroupGeneralInformationReady,
    getGroupExpressConfigurationReady,
    getGroupUsersConfigurationReady,
    (groupGeneralInformationReady, groupExpressConfigurationReady, groupUsersConfigurationReady) =>
        groupGeneralInformationReady && groupExpressConfigurationReady && groupUsersConfigurationReady
);

export const groupsSelector = createSelector(
    getGroups,
    groups => groups
);

export const totalGroupsSelector = createSelector(
    getTotalGroups,
    totalGroups => totalGroups
);

export const visibleGroupsSelector = createSelector(
    getGroups,
    groups => groups.length
);

export const isFetchingSelector = createSelector(
    getIsFetching,
    isFetching => isFetching
);

export const errorSelector = createSelector(
    getError,
    error => error
);

export const searchTextSelector = createSelector(
    getSearchText,
    searchText => searchText
);

export const isCreatingSelector = createSelector(
    getIsCreating,
    isCreating => isCreating
);

export const creationErrorSelector = createSelector(
    getCreationError,
    creationError => creationError
);

export const editionSelector = createSelector(
    getEdition,
    edition => edition
);

export const memberSuggestionsSelector = createSelector(
    getMembersSuggestion,
    memberSuggestions => memberSuggestions
);

export const suggestionsErrorSelector = createSelector(
    getSuggestionsError,
    suggestionsError => suggestionsError
);

export const totalMemberSuggestionsSelector = createSelector(
    getTotalMemberSuggestions,
    totalMemberSuggestions => totalMemberSuggestions
);

export const isFetchingMemberSuggestionsSelector = createSelector(
    getIsFetchingMemberSuggestions,
    isFetchingMemberSuggestions => isFetchingMemberSuggestions
);

export const membersSelector = createSelector(
    getMembers,
    members => members
);

export const memberCountSelector = createSelector(
    getMembers,
    members => members.length
);

export const musicOnHoldSelector = createSelector(
    getMusicOnHold,
    musicOnHold => musicOnHold
);

export const defaultExtensionSuggestionsSelector = createSelector(
    getDefaultExtensionSuggestions,
    defaultExtensionSuggestions => defaultExtensionSuggestions
);

export const defaultExtensionSearchTextSelector = createSelector(
    getDefaultExtensionSearchText,
    defaultExtensionSearchText => defaultExtensionSearchText
);

export const isFetchingDefaultExtensionSuggestionsSelector = createSelector(
    getIsFetchingDefaultExtensionSuggestions,
    isFetchingDefaultExtensionSuggestions => isFetchingDefaultExtensionSuggestions
);

export const totalDefaultExtensionSuggestionsSelector = createSelector(
    getTotalDefaultExtensionSuggestions,
    totalDefaultExtensionSuggestions => totalDefaultExtensionSuggestions
);
